export enum ECanvasPreferencesKeys {
  POIColor = 'Imaging.PlateViewer.PointOfInterestColor',
  DeleteScore = 'Experiment.Scores.Hotkey.DeleteScore',
  NameProteinLayerUsingPFName = 'Experiment.NameProteinLayerUsingPFName',
  RotateCanvasMessageBox = 'Screen.RotateCanvas.ShowMessageBox',
  AutoMoveAfterScoring = 'Imaging.PlateViewer.AutoMoveAfterScoring',
  SelectedCanvasScoreGroups = 'Imaging.PlateViewer.SelectedCanvasScoreGroups',
  SingleDropReport = 'SingleDropReport',
  SelectedWellColor = 'Canvas.SelectedWellColor',
  SelectedLayerColor = 'Canvas.SelectedLayerColor',
  SynchrotronTripReport = 'SynchrotronTripReport',
  RestartWellNavigationOnceEnd = 'Imaging.PlateViewer.RestartScoringOnceDone',
  ScoreWithoutImages = 'Scores.Score.ScoreWithoutImages',
}
